import { Map } from 'immutable';
import createReducer from './utils/createReducer';
import rsvp from 'rsvp';

/**
 * Plugins: loading, running
 *
 * @module plugins
 * @private
 */

const SET_API = 'SET_API';
const LOAD_PLUGIN = 'LOAD_PLUGIN';
const LOADING_PLUGIN = 'LOADING_PLUGIN';
const LOADED_PLUGIN = 'LOADED_PLUGIN';
const SET_PLUGIN = 'SET_PLUGIN';
const LOADING_PLUGIN_ERROR = 'LOADING_PLUGIN_ERROR';

const initialState = Map({
  api: null,
  plugins: Map(),
  loading: Map(),
});

const reducer = createReducer(initialState, {
  [SET_API](state, api) {
    return state.set('api', api);
  },

  [LOADING_PLUGIN](state, name) {
    return state.setIn(['loading', name], true);
  },

  [LOADED_PLUGIN](state, name, { action }) {
    return state.setIn(['loading', name], false);
  },

  [SET_PLUGIN](state, { name, plugin }) {
    return state.setIn(['plugins', name], plugin);
  },
});

function initPlugin(store, name, response) {
  try {
    function buildPluginFn(content) {
      const fn = new Function('api', content || '');
      return fn(store.getIn(['plugins', 'api']));
    }

    const { content, loadFromServer, url } = response;
    if (!loadFromServer)  return Promise.resolve(buildPluginFn(content));

    console.log('Load plugin from server', url);
    return new rsvp.Promise((resolve, reject) => {
      store.callApi({
        types: [LOADING_PLUGIN, LOADED_PLUGIN, LOADING_PLUGIN_ERROR],
        url,
        payload: name,
        queryKey: 'PLUGINexternal' + name,
        contentType: 'external',
      }).then((content) => {
        resolve(buildPluginFn(content));
      }).catch(function (e) {
        console.log('Error loading external plugin!', url);
        resolve({});
      });
    });
  } catch (e) {
    console.log('error', e);
  }
};

function loadPlugin(name) {
  return (store) => {
    const sceneId = store.getIn(['sceneIO', 'id']);
    if (!sceneId) return Promise.reject('No scene attached');

    const api = store.getIn(['plugins', 'api']);
    if (api && api[name]) return Promise.resolve(api[name]);

    return store.callApi({
      types: [LOADING_PLUGIN, LOADED_PLUGIN, LOADING_PLUGIN_ERROR],
      url: `${__APIROOT__}/scenes/${sceneId}/plugins/${name}`,
      payload: name,
      queryKey: 'PLUGIN' + name,
    }).then((response) => {
      return initPlugin(store, name, response).then(function (plugin) {
        store.dispatch({ type: SET_PLUGIN, payload: { name, plugin } });
        return plugin;
      });
    });
  };
}

export function get(store, name) {
  const plugin = store.getIn(['plugins', 'plugins', name]);
  return plugin ? Promise.resolve(plugin) : store.dispatch(loadPlugin(name));
}

export function setApi(api) {
  return { type: SET_API, payload: api };
}

/**
 * Returns a function that will run the setup command
 */
export function getSetupCommand(store, cmd, data) {
  try {
    function err(msg) {
      console.log(`Error getting plugin: ${pluginName}`);
      return Promise.resolve(true);
    }

    const [pluginName, command] = cmd.split('/');
    const setupData = typeof data === 'string' ? JSON.parse(data) : data;
    return function () {
      return get(store, pluginName).then(function (plugin) {
        if (!plugin) return err(`Error getting plugin: ${pluginName}`);
        if (!plugin[command]) return err(`Unknown command: ${command} for plugin: ${pluginName}`);
        if (typeof plugin[command] !== 'function') return err(`Command: ${command} in plugin: ${pluginName} is not a function`);

        if (Array.isArray(setupData)) {
          return Promise.resolve(plugin[command].apply(plugin, setupData));
        } else {
          return Promise.resolve(plugin[command](setupData));
        }
      });
    };
  } catch (e) {
    return function () { console.error(e); };
  }
}

const publicApi = {
  reducer,
  actions: { loadPlugin },
  selectors: { get, getSetupCommand },
};

export default publicApi;



// WEBPACK FOOTER //
// ./src/modules/plugins.js